import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "confined0": "chunk-page-by-username-4eba2e1d-confined0-WXUgJq",
  "confinedOffset10": "chunk-page-by-username-4eba2e1d-confinedOffset10-WXUgJq",
  "xwide5": "chunk-page-by-username-4eba2e1d-xwide5-WXUgJq",
  "col": "chunk-page-by-username-4eba2e1d-col-WXUgJq",
  "default11": "chunk-page-by-username-4eba2e1d-default11-WXUgJq",
  "confinedOffset6": "chunk-page-by-username-4eba2e1d-confinedOffset6-WXUgJq",
  "xwideOffset0": "chunk-page-by-username-4eba2e1d-xwideOffset0-WXUgJq",
  "xwideOffset2": "chunk-page-by-username-4eba2e1d-xwideOffset2-WXUgJq",
  "tinyOffset7": "chunk-page-by-username-4eba2e1d-tinyOffset7-WXUgJq",
  "tinyOffset8": "chunk-page-by-username-4eba2e1d-tinyOffset8-WXUgJq",
  "defaultOffset9": "chunk-page-by-username-4eba2e1d-defaultOffset9-WXUgJq",
  "wideOffset1": "chunk-page-by-username-4eba2e1d-wideOffset1-WXUgJq",
  "wideOffset7": "chunk-page-by-username-4eba2e1d-wideOffset7-WXUgJq",
  "wideOffset11": "chunk-page-by-username-4eba2e1d-wideOffset11-WXUgJq",
  "confined3": "chunk-page-by-username-4eba2e1d-confined3-WXUgJq",
  "tiny6": "chunk-page-by-username-4eba2e1d-tiny6-WXUgJq",
  "confined1": "chunk-page-by-username-4eba2e1d-confined1-WXUgJq",
  "defaultOffset8": "chunk-page-by-username-4eba2e1d-defaultOffset8-WXUgJq",
  "wide1": "chunk-page-by-username-4eba2e1d-wide1-WXUgJq",
  "xwideOffset4": "chunk-page-by-username-4eba2e1d-xwideOffset4-WXUgJq",
  "standardGridContainer": "chunk-page-by-username-4eba2e1d-standardGridContainer-WXUgJq",
  "row": "chunk-page-by-username-4eba2e1d-row-WXUgJq",
  "wide6": "chunk-page-by-username-4eba2e1d-wide6-WXUgJq",
  "wide10": "chunk-page-by-username-4eba2e1d-wide10-WXUgJq",
  "tiny10": "chunk-page-by-username-4eba2e1d-tiny10-WXUgJq",
  "xwide7": "chunk-page-by-username-4eba2e1d-xwide7-WXUgJq",
  "armstrongGridContainer": "chunk-page-by-username-4eba2e1d-armstrongGridContainer-WXUgJq",
  "xwide12": "chunk-page-by-username-4eba2e1d-xwide12-WXUgJq",
  "xwideOffset8": "chunk-page-by-username-4eba2e1d-xwideOffset8-WXUgJq",
  "xwideOffset5": "chunk-page-by-username-4eba2e1d-xwideOffset5-WXUgJq",
  "confinedOffset7": "chunk-page-by-username-4eba2e1d-confinedOffset7-WXUgJq",
  "tinyOffset1": "chunk-page-by-username-4eba2e1d-tinyOffset1-WXUgJq",
  "defaultOffset11": "chunk-page-by-username-4eba2e1d-defaultOffset11-WXUgJq",
  "confinedOffset8": "chunk-page-by-username-4eba2e1d-confinedOffset8-WXUgJq",
  "default8": "chunk-page-by-username-4eba2e1d-default8-WXUgJq",
  "xwideOffset6": "chunk-page-by-username-4eba2e1d-xwideOffset6-WXUgJq",
  "wideGridContainer": "chunk-page-by-username-4eba2e1d-wideGridContainer-WXUgJq",
  "tiny12": "chunk-page-by-username-4eba2e1d-tiny12-WXUgJq",
  "tiny3": "chunk-page-by-username-4eba2e1d-tiny3-WXUgJq",
  "tinyOffset10": "chunk-page-by-username-4eba2e1d-tinyOffset10-WXUgJq",
  "default1": "chunk-page-by-username-4eba2e1d-default1-WXUgJq",
  "confined8": "chunk-page-by-username-4eba2e1d-confined8-WXUgJq",
  "tinyOffset0": "chunk-page-by-username-4eba2e1d-tinyOffset0-WXUgJq",
  "defaultOffset3": "chunk-page-by-username-4eba2e1d-defaultOffset3-WXUgJq",
  "defaultOffset7": "chunk-page-by-username-4eba2e1d-defaultOffset7-WXUgJq",
  "wideOffset5": "chunk-page-by-username-4eba2e1d-wideOffset5-WXUgJq",
  "tiny4": "chunk-page-by-username-4eba2e1d-tiny4-WXUgJq",
  "tiny2": "chunk-page-by-username-4eba2e1d-tiny2-WXUgJq",
  "tinyOffset3": "chunk-page-by-username-4eba2e1d-tinyOffset3-WXUgJq",
  "confined7": "chunk-page-by-username-4eba2e1d-confined7-WXUgJq",
  "wide2": "chunk-page-by-username-4eba2e1d-wide2-WXUgJq",
  "wide11": "chunk-page-by-username-4eba2e1d-wide11-WXUgJq",
  "default2": "chunk-page-by-username-4eba2e1d-default2-WXUgJq",
  "xwide1": "chunk-page-by-username-4eba2e1d-xwide1-WXUgJq",
  "confinedOffset5": "chunk-page-by-username-4eba2e1d-confinedOffset5-WXUgJq",
  "confined6": "chunk-page-by-username-4eba2e1d-confined6-WXUgJq",
  "grid": "chunk-page-by-username-4eba2e1d-grid-WXUgJq",
  "tiny0": "chunk-page-by-username-4eba2e1d-tiny0-WXUgJq",
  "confinedOffset1": "chunk-page-by-username-4eba2e1d-confinedOffset1-WXUgJq",
  "confinedOffset11": "chunk-page-by-username-4eba2e1d-confinedOffset11-WXUgJq",
  "default0": "chunk-page-by-username-4eba2e1d-default0-WXUgJq",
  "defaultOffset10": "chunk-page-by-username-4eba2e1d-defaultOffset10-WXUgJq",
  "wideOffset9": "chunk-page-by-username-4eba2e1d-wideOffset9-WXUgJq",
  "wideOffset2": "chunk-page-by-username-4eba2e1d-wideOffset2-WXUgJq",
  "xwide11": "chunk-page-by-username-4eba2e1d-xwide11-WXUgJq",
  "defaultOffset5": "chunk-page-by-username-4eba2e1d-defaultOffset5-WXUgJq",
  "tinyOffset11": "chunk-page-by-username-4eba2e1d-tinyOffset11-WXUgJq",
  "tinyOffset4": "chunk-page-by-username-4eba2e1d-tinyOffset4-WXUgJq",
  "wideOffset6": "chunk-page-by-username-4eba2e1d-wideOffset6-WXUgJq",
  "xwideOffset7": "chunk-page-by-username-4eba2e1d-xwideOffset7-WXUgJq",
  "confinedOffset0": "chunk-page-by-username-4eba2e1d-confinedOffset0-WXUgJq",
  "tinyOffset9": "chunk-page-by-username-4eba2e1d-tinyOffset9-WXUgJq",
  "confined9": "chunk-page-by-username-4eba2e1d-confined9-WXUgJq",
  "xwide0": "chunk-page-by-username-4eba2e1d-xwide0-WXUgJq",
  "xwide9": "chunk-page-by-username-4eba2e1d-xwide9-WXUgJq",
  "tinyOffset2": "chunk-page-by-username-4eba2e1d-tinyOffset2-WXUgJq",
  "confinedOffset9": "chunk-page-by-username-4eba2e1d-confinedOffset9-WXUgJq",
  "wide9": "chunk-page-by-username-4eba2e1d-wide9-WXUgJq",
  "xwide8": "chunk-page-by-username-4eba2e1d-xwide8-WXUgJq",
  "xwide4": "chunk-page-by-username-4eba2e1d-xwide4-WXUgJq",
  "confinedOffset4": "chunk-page-by-username-4eba2e1d-confinedOffset4-WXUgJq",
  "tiny9": "chunk-page-by-username-4eba2e1d-tiny9-WXUgJq",
  "default7": "chunk-page-by-username-4eba2e1d-default7-WXUgJq",
  "wide5": "chunk-page-by-username-4eba2e1d-wide5-WXUgJq",
  "default12": "chunk-page-by-username-4eba2e1d-default12-WXUgJq",
  "tiny1": "chunk-page-by-username-4eba2e1d-tiny1-WXUgJq",
  "defaultOffset2": "chunk-page-by-username-4eba2e1d-defaultOffset2-WXUgJq",
  "confinedOffset3": "chunk-page-by-username-4eba2e1d-confinedOffset3-WXUgJq",
  "xwideOffset3": "chunk-page-by-username-4eba2e1d-xwideOffset3-WXUgJq",
  "confined4": "chunk-page-by-username-4eba2e1d-confined4-WXUgJq",
  "wide8": "chunk-page-by-username-4eba2e1d-wide8-WXUgJq",
  "tiny8": "chunk-page-by-username-4eba2e1d-tiny8-WXUgJq",
  "tiny11": "chunk-page-by-username-4eba2e1d-tiny11-WXUgJq",
  "default4": "chunk-page-by-username-4eba2e1d-default4-WXUgJq",
  "confinedOffset2": "chunk-page-by-username-4eba2e1d-confinedOffset2-WXUgJq",
  "tinyOffset5": "chunk-page-by-username-4eba2e1d-tinyOffset5-WXUgJq",
  "wideOffset3": "chunk-page-by-username-4eba2e1d-wideOffset3-WXUgJq",
  "confined12": "chunk-page-by-username-4eba2e1d-confined12-WXUgJq",
  "wideOffset8": "chunk-page-by-username-4eba2e1d-wideOffset8-WXUgJq",
  "default10": "chunk-page-by-username-4eba2e1d-default10-WXUgJq",
  "defaultOffset1": "chunk-page-by-username-4eba2e1d-defaultOffset1-WXUgJq",
  "tiny5": "chunk-page-by-username-4eba2e1d-tiny5-WXUgJq",
  "confined5": "chunk-page-by-username-4eba2e1d-confined5-WXUgJq",
  "wide12": "chunk-page-by-username-4eba2e1d-wide12-WXUgJq",
  "xwideOffset9": "chunk-page-by-username-4eba2e1d-xwideOffset9-WXUgJq",
  "default9": "chunk-page-by-username-4eba2e1d-default9-WXUgJq",
  "wideOffset0": "chunk-page-by-username-4eba2e1d-wideOffset0-WXUgJq",
  "xwideOffset10": "chunk-page-by-username-4eba2e1d-xwideOffset10-WXUgJq",
  "wideOffset10": "chunk-page-by-username-4eba2e1d-wideOffset10-WXUgJq",
  "default3": "chunk-page-by-username-4eba2e1d-default3-WXUgJq",
  "wide4": "chunk-page-by-username-4eba2e1d-wide4-WXUgJq",
  "defaultOffset4": "chunk-page-by-username-4eba2e1d-defaultOffset4-WXUgJq",
  "confined10": "chunk-page-by-username-4eba2e1d-confined10-WXUgJq",
  "xwideOffset1": "chunk-page-by-username-4eba2e1d-xwideOffset1-WXUgJq",
  "default6": "chunk-page-by-username-4eba2e1d-default6-WXUgJq",
  "tiny7": "chunk-page-by-username-4eba2e1d-tiny7-WXUgJq",
  "confined2": "chunk-page-by-username-4eba2e1d-confined2-WXUgJq",
  "defaultOffset6": "chunk-page-by-username-4eba2e1d-defaultOffset6-WXUgJq",
  "xwide6": "chunk-page-by-username-4eba2e1d-xwide6-WXUgJq",
  "xwide3": "chunk-page-by-username-4eba2e1d-xwide3-WXUgJq",
  "gridContainer": "chunk-page-by-username-4eba2e1d-gridContainer-WXUgJq",
  "confined11": "chunk-page-by-username-4eba2e1d-confined11-WXUgJq",
  "wide7": "chunk-page-by-username-4eba2e1d-wide7-WXUgJq",
  "tinyOffset6": "chunk-page-by-username-4eba2e1d-tinyOffset6-WXUgJq",
  "wide0": "chunk-page-by-username-4eba2e1d-wide0-WXUgJq",
  "xwide2": "chunk-page-by-username-4eba2e1d-xwide2-WXUgJq",
  "xwide10": "chunk-page-by-username-4eba2e1d-xwide10-WXUgJq",
  "wide3": "chunk-page-by-username-4eba2e1d-wide3-WXUgJq",
  "xwideOffset11": "chunk-page-by-username-4eba2e1d-xwideOffset11-WXUgJq",
  "wideOffset4": "chunk-page-by-username-4eba2e1d-wideOffset4-WXUgJq",
  "default5": "chunk-page-by-username-4eba2e1d-default5-WXUgJq"
};